























































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LayerType } from '../../../../common/board';
import moment, { Moment } from 'moment';
import gql from 'graphql-tag';

import * as FAVORITE_BOARDS_QUERY from 'src/graphql/FavoriteBoards.graphql';
import * as FAVORITE_BOARD_NAME_FRAGMENT_QUERY from 'src/graphql/FavoriteBoardNameFragment.graphql';

export enum BoardType {
  ALL,
  SINGLE,
  DOUBLE,
  TRIPPLE
}

@Component({
  components: {

  },
  apollo: {
    favorite_boards_for_group: {
      query: FAVORITE_BOARDS_QUERY,
      variables() {
        return {
          group: !this.enableSelect && this.group ? this.group.name : null,
        }
      },
      skip() {
        return !this.enableSelect && !this.group;
      },
      fetchPolicy: 'network-only',
    },
  }
})
export default class FavoriteBoardsCard extends Vue {
  $refs: any;

  @Prop() value: any;
  @Prop({ default: true }) enableSelect: boolean;
  @Prop({ default: null }) groupName: string;
  @Prop({ default: false }) dialogValue: boolean;

  get group() {
    return this.$store.state.currentGroupPermission;
  }

  @Watch('dialogValue')
  onDialogValueChanged() {
    if (this.dialogValue) {
      this.$apollo.queries.favorite_boards_for_group.refetch();
    }
  }

  @Watch('favorite_boards_for_group')
  onFavoriteBoardsChanged() {
    this.$store.commit('setFavoriteBoardNames', this.favorite_boards_for_group.map(board => {
      return { name: board.name, id: board.id };
    }));
  }


  // This is needed to access the type in the template.
  BoardType = BoardType;
  selectedBoardType = BoardType.ALL;

  search = '';
  selectedFavoriteBoard = null;
  hovered = -1;

  favoriteBoardNameRules = [
    name => !this.checkIfFavoriteBoardExists(name) || 'Favorite board already exists and will be replaced',
  ];

  pagination = {
    sortBy: 'name',
    descending: false,
  };

  headers = [
    { text: '',          align: 'left',  sortable: false,  value: 'select',  width: '48px' },
    { text: 'Name',      align: 'left',                    value: 'name',    minWidth: '140px' },
    { text: '',          align: 'right', sortable: false,  value: 'name_edit',                 class: 'empty-header' },
    { text: 'Papers',                                      value: 'layers',                    class: 'pl-0' },
    { text: 'Created',   align: 'right',                   value: 'created_at',                class: 'pr-0' },
    { text: 'Last Used', align: 'right',                   value: 'used_at',                   class: 'pr-0' },
    { text: '',          align: 'right', sortable: false,  value: 'delete',                    class: 'empty-header' },
  ];

  favorite_boards_for_group = [];

  deleteBoardDialog = -1;
  replaceBoardDialog = -1;

  editNameDialog = -1;
  editOriginalName = '';
  editName = '';

  @Watch('value')
  onValueChanged() {
    this.selectedFavoriteBoard = this.value;
  }

  @Watch('selectedFavoriteBoard')
  onSelectedFavoriteBoardChanged() {
    this.$emit('input', this.selectedFavoriteBoard);
  }

  fromNow(date) {
    return date ? moment(date).fromNow() : 'never';
  }

  filter(favorite, search) {
    if (favorite == null) {
      return false;
    }

    if (typeof favorite === 'string') {
      return favorite.toLowerCase().includes(search);
    }

    if (moment.isMoment(favorite)) {
      return (<Moment>favorite).fromNow().toLowerCase().includes(search);
    }

    if (favorite instanceof Array) {
      for (const layer of favorite) {
        if (this.latestPaperName(layer.paper).toLowerCase().includes(search))
          return true;
        if (layer.flute != null && `[${this.latestFluteName(layer.flute)}]`.toLowerCase().includes(search))
          return true;
      }
    }

    return false;
  }

  changeSort(column) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  mouseOver(id) {
    this.hovered = id;
  }

  mouseLeave() {
    this.hovered = -1;
  }

  closeDeleteDialog() {
    this.deleteBoardDialog = -1;
  }

  closeReplaceBoardDialog() {
    this.replaceBoardDialog = -1;
  }

  openEditNameDialog(board) {
    this.editOriginalName = board.name;
    this.editName = board.name;
    this.editNameDialog = board.id;

    setTimeout(() => {
      const input = this.$refs['editFavoriteNameRef' + board.id];
      if (input) {
        input.focus();
        input.$el.querySelector('input').select()
      }
    }, 50);
  }

  closeEditNameDialog() {
    this.editNameDialog = -1;
    this.editOriginalName = '';
    this.editName = '';
  }

  isOriginalName(name) {
    if (name == null || this.editOriginalName == null)
      return false;

    // This is used to disable the Save/Replace button.
    return name.trim() === this.editOriginalName.trim();
  }

  isOriginalNameLowerCase(name) {
    if (name == null || this.editOriginalName == null)
      return false;

    // This is used to check if the Save button should be Replace instead.
    return name.trim().toLowerCase() === this.editOriginalName.trim().toLowerCase();
  }

  checkIfFavoriteBoardExists(name) {
    // Ignore the original name, but only in lowercase, so that we can save a new name with only a change in casing.
    return !this.isOriginalNameLowerCase(name) && this.$store.getters.hasFavoriteBoard(name);
  }

  selectFavoriteBoard(item) {
    if (this.enableSelect)
      this.selectedFavoriteBoard = item;
  }

  layerIsPaper(layer) {
    return layer.type === LayerType[LayerType.PAPER];
  }

  latestPaperName(paper) {
    if (paper == null)
      return '';
    else
      return paper.newest ? paper.newest.CEPI_name : paper.CEPI_name;
  }

  latestFluteName(flute) {
    if (flute == null)
      return '';
    else
      return flute.newest ? flute.newest.name : flute.name;
  }

  papersAsString(item) {
    let result = [];

    for (const layer of item.layers) {
      const paperName = this.latestPaperName(layer.paper);
      if (layer.type === LayerType[LayerType.PAPER]) {
        result.push(paperName);
      } else {
        const fluteName = this.latestFluteName(layer.flute);
        result.push(`${paperName} [${fluteName}]`);
      }
    }

    return result.join(', ');
  }

  deleteFavoriteBoard(board) {
    this.$store.commit('deleteFavoriteBoard', board);

    this.closeDeleteDialog();
  }

  saveEditName(board) {
    if (this.editName != '') {
      this.$apollo.mutate({
        mutation: gql`mutation ($favoriteBoardId: Int!, $name: String!) {
            updateFavoriteBoardName(favoriteBoardId: $favoriteBoardId, name: $name) {
              ...FavoriteBoardName
            }
          }
          ${FAVORITE_BOARD_NAME_FRAGMENT_QUERY}
        `,
        variables: {
          favoriteBoardId: board.id,
          name: this.editName.trim(),
        },
        update: (store, {data: { updateFavoriteBoardName }}) => {
          let data = JSON.parse(JSON.stringify(board));
          data.name = updateFavoriteBoardName.name;

          store.writeFragment({
            id: `FavoriteBoard:${board.id}`,
            fragment: FAVORITE_BOARD_NAME_FRAGMENT_QUERY,
            data: data,
          });

        },
        optimisticResponse: {
          __typename: 'Mutation',
          updateFavoriteBoardName: {
            __typename: 'FavoriteBoard',
            name: this.editName,
          },
        },
      });

      this.closeEditNameDialog();
    }
  }

  async replaceEditName(board) {
    const oldBoard = this.$store.state.favorite_board_names.find( board => board.name.trim().toLowerCase() === this.editName.trim().toLowerCase() );
    if (oldBoard) {
      await this.$store.commit('deleteFavoriteBoard', oldBoard);
    }

    this.saveEditName(board);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/FavoriteBoardsCard.vue